export default __webpack_public_path__ + "static/media/ban-desktop-image-7.205f4442.jpg";